import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track } from "@/lib/analytics";

/**
 * Fires a pageview on every SPA route change. Mounted inside <BrowserRouter>.
 */
export default function PageviewTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    track("pageview");
  }, [pathname]);
  return null;
}
